import { useEffect, useRef } from "react";
import { ADSENSE } from "@/config/monetization";

let scriptPromise = null;

function loadAdSenseScript() {
    if (!ADSENSE.client) return Promise.resolve(false);
    if (window.adsbygoogle) return Promise.resolve(true);
    if (document.querySelector('script[src*="adsbygoogle.js"]')) return Promise.resolve(true);
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise((resolve) => {
        const script = document.createElement("script");
        script.async = true;
        script.crossOrigin = "anonymous";
        script.dataset.adsenseScript = "true";
        script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(ADSENSE.client)}`;
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.head.appendChild(script);
    });
    return scriptPromise;
}

const AdSenseUnit = ({ slot, format, className = "" }) => {
    const ref = useRef(null);
    const requested = useRef(false);

    useEffect(() => {
        if (!ADSENSE.client || !slot || requested.current) return;
        requested.current = true;
        loadAdSenseScript().then((loaded) => {
            if (!loaded || !ref.current) return;
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (e) {
                // adblock ou slot inválido não deve quebrar a página
            }
        });
    }, [slot]);

    return (
        <div className={`w-full overflow-hidden ${className}`}>
            <ins
                ref={ref}
                className="adsbygoogle block w-full"
                style={{ display: "block", minHeight: 90 }}
                data-ad-client={ADSENSE.client}
                data-ad-slot={slot}
                data-ad-format={format}
                data-full-width-responsive="true"
            />
        </div>
    );
};

const AdFrame = ({ children, label = "Publicidade", testId }) => (
    <div data-testid={testId} className="w-full">
        <span className="block text-[10px] uppercase tracking-[0.25em] text-slate-600 mb-2">{label}</span>
        {children}
    </div>
);

const Placeholder = ({ height = "h-28" }) => (
    <div className={`flex items-center justify-center border border-dashed border-white/15 bg-white/[0.02] ${height}`}>
        <span className="text-[11px] uppercase tracking-[0.3em] text-slate-700">Google AdSense</span>
    </div>
);

export const LeaderboardAd = () => {
    if (ADSENSE.client && !ADSENSE.slots.leaderboard) return null; // Auto Ads cobre
    return (
        <AdFrame testId="ad-leaderboard">
            {ADSENSE.client
                ? <AdSenseUnit slot={ADSENSE.slots.leaderboard} format="horizontal" className="mx-auto max-w-[970px]" />
                : <Placeholder height="h-24 md:h-28" />}
        </AdFrame>
    );
};

export const InFeedAd = () => {
    if (ADSENSE.client && !ADSENSE.slots.inFeed) return null;
    return (
        <AdFrame testId="ad-in-feed">
            {ADSENSE.client
                ? <AdSenseUnit slot={ADSENSE.slots.inFeed} format="fluid" />
                : <Placeholder height="h-full min-h-[240px]" />}
        </AdFrame>
    );
};

export const InArticleAd = () => {
    if (ADSENSE.client && !ADSENSE.slots.inArticle) return null;
    return (
        <AdFrame testId="ad-in-article">
            {ADSENSE.client
                ? <AdSenseUnit slot={ADSENSE.slots.inArticle} format="fluid" />
                : <Placeholder height="h-32" />}
        </AdFrame>
    );
};
